package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.bingeamigo.model.types.ActivityType
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource
import kotlin.math.absoluteValue

@Composable
fun FriendAvatar(
    username: String,
    modifier: Modifier = Modifier,
    photoUrl: String? = null,
    size: Dp = 42.dp,
    type: ActivityType? = null,
) {
    val (a, b) = gradientFor(username)
    Box(modifier = modifier.size(size)) {
        Box(
            modifier = Modifier
                .size(size)
                .clip(CircleShape)
                .background(Brush.linearGradient(listOf(a, b))),
            contentAlignment = Alignment.Center,
        ) {
            if (!photoUrl.isNullOrBlank()) {
                KamelImage(
                    resource = asyncPainterResource(photoUrl),
                    contentDescription = username,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.size(size).clip(CircleShape),
                )
            } else {
                Text(
                    text = username.take(1).uppercase(),
                    color = Color.White,
                    fontWeight = FontWeight.ExtraBold,
                    fontSize = (size.value * 0.4f).sp,
                )
            }
        }
        val badge = badgeFor(type)
        if (badge != null) {
            Box(
                modifier = Modifier
                    .align(Alignment.BottomEnd)
                    .size(17.dp)
                    .clip(CircleShape)
                    .background(badge.second)
                    .border(2.dp, BrandColors.Background, CircleShape),
                contentAlignment = Alignment.Center,
            ) {
                Text(badge.first, fontSize = 9.sp)
            }
        }
    }
}

private fun gradientFor(seed: String): Pair<Color, Color> {
    val palettes = listOf(
        Color(0xFFFF8A4C) to Color(0xFFD6356B),
        Color(0xFF3AD1C4) to Color(0xFF2B6CF0),
        Color(0xFF9B6BFF) to Color(0xFF5A2BD0),
        Color(0xFFFFD14C) to Color(0xFFFF7A2C),
        Color(0xFF4CD07A) to Color(0xFF1F8A8A),
    )
    return palettes[(seed.hashCode().absoluteValue) % palettes.size]
}

private fun badgeFor(type: ActivityType?): Pair<String, Color>? = when (type) {
    ActivityType.EPISODE_WATCHED, ActivityType.MARK_WATCHED -> "👁" to BrandColors.Secondary
    ActivityType.FAVORITE_MOVIE, ActivityType.FAVORITE_SHOW -> "❤" to Color(0xFFE0567A)
    ActivityType.RATE_MOVIE, ActivityType.RATE_SHOW, ActivityType.RATE_EPISODE -> "★" to BrandColors.Primary
    ActivityType.COMPLETE_SHOW -> "✓" to Color(0xFF34D29A)
    ActivityType.ADD_WATCHLIST, ActivityType.ADD_SHOW_TRACKING -> "🔖" to BrandColors.Secondary
    else -> null
}
